import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import PinkGradientButton from './PinkGradientButton';

const ChangePlanModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure you want to change your plan?',
  message = (
    <>
      Please confirm that you want to proceed with updating your subscription plan. <br/>Please note immediate payment will occur using the billing details you provided before.
    </>
  ),
  confirmText = 'Yes, update',
  cancelText = 'No, go back',
  actionJustifyContent = { xs: 'center', sm: 'flex-end' },
}) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="change-plan-dialog" PaperProps={{
        className:'dialog-container',
        sx: {
          p: { xs: 2, sm: 4 },
          minWidth: { xs: 'auto', sm: '500px' },
          maxWidth: '711px',
          borderRadius: 4,
          width: { xs: 'calc(100% - 32px)', sm: 'auto' },
          m: { xs: 2, sm: 4 },
        },
      }}>
      <DialogTitle
        variant="h4"
        sx={{
          p: 0,
          fontWeight: 600,
          fontSize: { xs: '30px', sm: '2.125rem' },
          lineHeight: { xs: '36px', sm: 1.235 },
        }}
      >
          {title}
      </DialogTitle>
      <DialogContent sx={{ p:0, mt: 3, mb: 4 }}>
        <Typography variant="body1" sx={{ color: '#616063' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: actionJustifyContent, p: 0, alignItems: 'center',  flexDirection: { xs: 'column', sm: 'row' } }}>
        <PinkGradientButton
          onClick={onConfirm}
          variant="contained"
          sx={{m:0}}
        >
          {confirmText}
        </PinkGradientButton>
        <Button
          onClick={onClose}
          className='black-btn'
          sx={{
            color: '#0b0c26',
            textDecoration: 'underline',
            textTransform: 'none',
            fontWeight: 600,
            justifyContent: 'center'
          }}
        >
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePlanModal;
